import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makeGetRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* fetchSettings() {
  try {
    const url = '/v1/organization/settings'
    const settings = yield makeGetRequest(url)

    yield put({
      type: ACT.SETTINGS_FETCH_SUCCESS,
      payload: {
        settings
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Settings',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const usersSagas = [takeLatest(ACT.SETTINGS_FETCH_REQUESTED, fetchSettings)]

export default usersSagas
